export const sortingCountry = (list) => {
  let newList = list;

  newList.sort(function (a, b) {
    const nameA = a.name.toLowerCase();
		const nameB = b.name.toLowerCase();
    if (nameA < nameB)
      
      return -1;
    if (nameA > nameB) return 1;
    return 0; 
  });

	newList.sort(function(x,y){ 
		return x.name === 'Canada' ? -1 : y.name === 'Canada' ? 1 : 0; 
	});

	newList.sort(function(x,y){ 
		return x.code === 'US' ? -1 : y.code === 'US' ? 1 : 0; 
	});
	

  return newList;
};
